module.exports = __webpack_public_path__ + "img/car-22.7d8c178f.jpg";